import { render, staticRenderFns } from "./IOT.vue?vue&type=template&id=37bed82d&scoped=true&"
import script from "./IOT.vue?vue&type=script&lang=js&"
export * from "./IOT.vue?vue&type=script&lang=js&"
import style0 from "./IOT.vue?vue&type=style&index=0&id=37bed82d&prod&lang=scss&scoped=true&"
import style1 from "./IOT.vue?vue&type=style&index=1&id=37bed82d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bed82d",
  null
  
)

export default component.exports